import { CAGroup } from '@/types/model/corrective-action';

const includesText = (value: string | null | undefined, query: string): boolean => {
  if (!value) {
    return false;
  }

  return value.toLowerCase().includes(query);
};

export const filterCorrectiveActionGroupsBySearch = (
  groups: CAGroup[],
  searchQuery: string
): CAGroup[] => {
  const normalized = searchQuery.trim().toLowerCase();
  if (!normalized) {
    return groups;
  }

  return groups
    .map((group) => {
      const groupIdentifierText = String(group.groupIdentifier);
      const groupMatches = includesText(groupIdentifierText, normalized) || includesText(group.title, normalized);
      if (groupMatches) {
        return group;
      }

      const nextLineItems = group.lineItems?.filter((lineItem) => {
        return (
          includesText(lineItem.lineItem, normalized)
          || includesText(lineItem.title, normalized)
        );
      }) ?? null;

      return {
        ...group,
        lineItems: nextLineItems,
      };
    })
    .filter((group) => (group.lineItems?.length ?? 0) > 0);
};
